// 🔴 L2 (N°876) — client HTTP des écrans ARTISAN (client → site → dossier).
//
// 🔑 CAS C (N°877) : ce module ⛔ n'appelle QUE `/api/metier/*` et
// `/api/governance/*`. ⛔ Aucune route du DAL gelé, ni importée,
// ni recopié — vérifié par `garde_frontiere_artisan.test.js`.
const API = process.env.REACT_APP_BACKEND_URL || "";
const e = encodeURIComponent;

function entetes() {
  let jeton = null;
  try { jeton = localStorage.getItem("session_token"); } catch { /* indisponible */ }
  return { "Content-Type": "application/json",
           ...(jeton && { Authorization: `Bearer ${jeton}` }) };
}

export async function appel(chemin, options = {}) {
  const r = await fetch(`${API}${chemin}`, { credentials: "include",
                                             headers: entetes(), ...options });
  const j = await r.json().catch(() => ({}));
  if (!r.ok) {
    const d = j?.detail;
    throw new Error(typeof d === "string" ? d : `Échec (HTTP ${r.status})`);
  }
  return j;
}

export const sitesDuClient = (clientId) =>
  appel(`/api/metier/clients/${e(clientId)}/sites`);
export const lireSite = (siteId) => appel(`/api/metier/sites/${e(siteId)}`);
export const creerSite = (clientId, data) =>
  appel(`/api/metier/clients/${e(clientId)}/sites`,
        { method: "POST", body: JSON.stringify(data) });
export const rattacherSite = (dossierId, siteId) =>
  appel(`/api/metier/dossiers/${e(dossierId)}/site`,
        { method: "POST", body: JSON.stringify({ site_id: siteId }) });
export const creerDossierSurSite = (clientId, siteId, activite) =>
  appel("/api/metier/dossiers", { method: "POST",
    body: JSON.stringify({ client_id: clientId, site_id: siteId, activite }) });
export const devisDuDossier = (dossierId) =>
  appel(`/api/metier/devis?dossier_id=${e(dossierId)}`);
// 🔴 N°966 — Devis → Facture par la capacité PARTAGÉE OH Facturation (⛔ aucun
//    endpoint spécifique Mario) : éligibilité (devis déjà facturé / facturable) et
//    création depuis devis. Le serveur applique capability `commercial.factures`,
//    porte VH3, mentions légales, numérotation et idempotence (index unique).
export const eligibiliteFactures = (devisIds) =>
  appel("/api/metier/factures/eligibilite",
        { method: "POST", body: JSON.stringify({ devis_ids: devisIds }) });
// 🔴 N°975 — émettre un devis brouillon par la route NATIVE partagée (la même que
//    `DevisFacturesTab` pour un devis « draft ») : numéro, gel, identité légale, GED.
export const emettreDevis = (devisId) =>
  appel(`/api/metier/devis/${e(devisId)}/emettre`, { method: "POST" });
export const creerFactureDepuisDevis = (devisId) =>
  appel("/api/metier/factures/depuis-devis",
        { method: "POST", body: JSON.stringify({ devis_id: devisId }) });
export const pipelinesDuTenant = () => appel("/api/governance/pipelines");
// 🔴 N°975 — Relevé → Devis par le PONT SERVEUR existant (Mario V1 · B) : valorisé par
//    le catalogue, idempotent (un relevé = un devis), ⛔ aucune logique métier ici.
export const creerDevisDepuisReleve = (releveId) =>
  appel(`/api/metier/mario/sessions/${e(releveId)}/devis`, { method: "POST" });
/** PDF d'un devis, lu AVEC la session (⛔ un simple lien n'emporte pas l'en-tête
 *  d'authentification) : la route documentaire PARTAGÉE, ⛔ aucun rendu ici. */
export async function pdfDevis(devisId) {
  const r = await fetch(`${API}/api/metier/documents/devis/${e(devisId)}/pdf`,
                        { credentials: "include", headers: entetes() });
  if (!r.ok) {
    const j = await r.json().catch(() => ({}));
    throw new Error(typeof j?.detail === "string" ? j.detail : `PDF indisponible (HTTP ${r.status})`);
  }
  return r.blob();
}

/** L'activité DÉCLARÉE par le tenant (`config.dossier_activite`) — ⛔ jamais devinée. */
export function activiteDuTenant() {
  try { return localStorage.getItem("current_dossier_activite") || null; } catch { return null; }
}
